import React, { useContext } from "react";
import { TodoContext } from "../../TodoContext";
import "./TodoCounter.css";

const TodoCounter = () => {
  const { totalTodos, completedTodos } = useContext(TodoContext);

  return (
    <h1 className="TodoCounter">
      Has completado {completedTodos} de {totalTodos} tareas
    </h1>
  );
};

export default TodoCounter;
